@if (loading$ | async) {
  <app-is-loading></app-is-loading>
}

<body>
  <div>
    @if (systemParameters[0] != null && systemParameters[0] != undefined) {
      <h3>{{systemParameters[0].parameterValue1}}</h3>
    }
    <span class="pageHeader">Contact Us</span>
    @if (hasParameterValue(12)) {
      <p>{{systemParameters[12].parameterValue1}}</p>
    }
    @if (!hasParameterValue(12)) {
      <p>Please contact
        @if (systemParameters[4] != null && systemParameters[4] != undefined && systemParameters[4].parameterValue1 != '' && systemParameters[4].parameterValue1 != null) {
          the {{systemParameters[4].parameterValue1}} at
        }
        @if ((systemParameters[4] == null || systemParameters[4] == undefined || systemParameters[4].parameterValue1 == '' && systemParameters[4].parameterValue1 != null) && systemParameters[3] != null && systemParameters[3] != undefined && systemParameters[3].parameterValue1 != '' && systemParameters[3].parameterValue1 != null) {
          the {{systemParameters[3].parameterValue1}} at
        }
        the Administrative Office with any questions about the
        Web Employer Reporting Form (WebERF).
      </p>
    }
  </div>

  <div>
    @if (hasParameterValue(0) || hasParameterValue(1) || hasParameterValue(2)) {
      <strong>Mailing Address:</strong><br />
      {{systemParameters[0].parameterValue1}} <br/>
      {{systemParameters[1].parameterValue1}} <br/>
      {{systemParameters[2].parameterValue1}} <br/>
    }
    @if (hasParameterValue(7)) {
      <strong>Phone:</strong>&nbsp;
      {{systemParameters[7].parameterValue1}} <br/>
    }
    @if (hasParameterValue(8)) {
      <strong>Phone 2:</strong>&nbsp;
      {{systemParameters[8].parameterValue1}} <br/>
    }
    @if (hasParameterValue(9)) {
      <strong>Toll free:</strong>&nbsp;
      {{systemParameters[9].parameterValue1}} <br/>
    }
    @if (hasParameterValue(6)) {
      <strong>Fax:</strong>&nbsp;
      {{systemParameters[6].parameterValue1}} <br/>
    }
    @if (hasParameterValue(5)) {
      <strong>Email:</strong>&nbsp;
      {{systemParameters[5].parameterValue1}} <br/>
    }
    @if (hasParameterValue(3)) {
      <strong>Attn:</strong>&nbsp;
      {{systemParameters[3].parameterValue1}} <br/>
    }
    @if (hasParameterValue(11)) {
      <strong>Plan Administrator:</strong>&nbsp;
      {{systemParameters[11].parameterValue1}} <br/>
    }
  </div>
  @if (hasParameterValue(10)) {
    <p>{{systemParameters[10].parameterValue1}}</p>
  }

  @if (!this.authService.isUserSignedin()) {
    <a href="/login" style="text-decoration: underline;">Back to Login</a>
  }
</body>